import "can/component/";
import "can/view/stache/";


can.Component.extend({
    tag: "loading-indicator",
    template: can.view("src/components/loading-indicator/loading-indicator.stache"),
});
